'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = elements;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _fp = require('lodash/fp');

var _elementHelper = require('./elementHelper');

var _scoreCalculator = require('./listOrderScores/scoreCalculator');

var _elementReducer = require('./elementReducer');

var _elementConstants = require('./elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

var _elementsConstants = require('./elementsConstants');

var ELEMENTS_ACTION_TYPES = _interopRequireWildcard(_elementsConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants
var initialState = Immutable.Map();

// Reducers


// Utils
// Lib


var loadElements = function loadElements(state, action) {
    var updatedState = state;
    if (action.deletedElementIds && action.deletedElementIds.length) {
        updatedState = updatedState.filter(function (el) {
            return !(0, _fp.includes)(el.get('id'), action.deletedElementIds);
        });
    }

    return updatedState.mergeDeep(action.elements);
};

var createElement = function createElement(state, action) {
    // step 1: create the element
    var newElement = (0, _elementReducer.element)(null, action);
    if (!newElement) return state;

    // step 2: insert element into the master element Map
    return state.set(newElement.get('id'), newElement);
};

var deleteElement = function deleteElement(state, action) {
    return state.delete(action.id);
};

/**
 * Delegates the handling of the action to each element in the action's ids list.
 * If an element does not exist, does nothing.
 */
var delegateToEachElementIfExists = function delegateToEachElementIfExists(iterablePropName) {
    return function (state, action) {
        return state.withMutations(function (mutableState) {
            action[iterablePropName].forEach(function (prop) {
                // If we don't have the element then we cannot update it
                if (!mutableState.get(prop.id)) return;
                mutableState.update(prop.id, function (el) {
                    return (0, _elementReducer.element)(el, action);
                });
            });
        });
    };
};

var delegateUpdateToEachElementIfExists = delegateToEachElementIfExists('updates');
var delegateMoveToEachElementIfExists = delegateToEachElementIfExists('moves');

/**
 * Delegates the handling of the action to the element which has been specified in the action.id.
 * If the element does not exist, does nothing.
 */
var delegateToElementIfExists = function delegateToElementIfExists(state, action) {
    // If we don't have the element then we cannot update it
    if (!state.get(action.id)) return state;
    return state.update(action.id, function (el) {
        return (0, _elementReducer.element)(el, action);
    });
};

var resetScores = function resetScores(state, action) {
    // Gets the inbox children in sorted order based on their current scores
    var inboxChildren = (0, _elementHelper.getSortedChildrenInSection)(state, action.section, action.parentId);
    // Calculates the new 'reset' scores to use for each child
    var resetScoresArray = (0, _scoreCalculator.calculateResetScores)(inboxChildren.length);

    // Loop over each child (in order) and replace their current score with the new, reset score.
    var updatedInboxElementMap = inboxChildren.reduce(function (elementMap, inboxElement, index) {
        elementMap[inboxElement.get('id')] = inboxElement.setIn(['location', 'position', 'score'], resetScoresArray[index]);
        return elementMap;
    }, {});

    return state.merge(updatedInboxElementMap);
};

/**
 *
 * @param state
 * @param action
 * @returns {*}
 */
function elements() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case ELEMENTS_ACTION_TYPES.ELEMENTS_LOAD:
            return loadElements(state, action);
        case TYPES.ELEMENT_CREATE:
            return createElement(state, action);
        case TYPES.ELEMENT_DELETE:
            return deleteElement(state, action);
        case TYPES.ELEMENT_UPDATE:
            return delegateUpdateToEachElementIfExists(state, action);
        case TYPES.ELEMENT_MOVE_MULTI:
            return delegateMoveToEachElementIfExists(state, action);
        case TYPES.ELEMENT_SET_TYPE:
        case TYPES.ELEMENT_UNSHARE:
        case TYPES.ELEMENT_SHARE:
        case TYPES.ELEMENT_MOVE_AND_UPDATE:
            return delegateToElementIfExists(state, action);
        // Attachment uploads
        case TYPES.ELEMENT_ATTACHMENT_UPLOADING:
        case TYPES.ELEMENT_ATTACHMENT_DATA_READY:
        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_PROGRESSED:
        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_COMPLETED:
        case TYPES.ELEMENT_ATTACHMENT_CLEAN:
        case TYPES.ELEMENT_ATTACHMENT_UPLOAD_ERROR:
        case TYPES.ELEMENT_ATTACHMENT_CLEAR_ERROR:
        case TYPES.ELEMENT_ICON_FIND:
        case TYPES.ELEMENT_ICON_FIND_SUCCESS:
        case TYPES.ELEMENT_ICON_FIND_FAILURE:
        case TYPES.ELEMENT_ICON_SEARCH:
            return delegateToElementIfExists(state, action);
        case ELEMENTS_ACTION_TYPES.ELEMENTS_RESET_SCORES:
            return resetScores(state, action);
        // TODO Restructure so that the elements reducer is no longer in 'common'
        case 'LOGIN_SUBMIT':
            return initialState;
        default:
            return state;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementsReducer.js
// module id = 2270
// module chunks = 0